import {
  AI_PLATFORM_DUOMI,
  normalizeCatalogPlatformId,
} from '../constants/aiPlatforms'

/**
 * 判断指定平台+模型是否支持参考图（以服务端 catalog 下发为准）
 */
export function isReferenceImageUploadSupported(
  platformId: string,
  modelId: string,
  imageModels: readonly { id: string; platform?: string; supportsReferenceImages?: boolean }[],
): boolean {
  const pid = normalizeCatalogPlatformId(platformId) ?? platformId.trim()
  const m = imageModels.find((row) => {
    const rowPlatform = normalizeCatalogPlatformId(row.platform ?? AI_PLATFORM_DUOMI) ?? AI_PLATFORM_DUOMI
    return row.id === modelId.trim() && rowPlatform === pid
  })
  return m?.supportsReferenceImages === true
}
